import React, { useState, useEffect } from 'react';
import classnames from 'classnames';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { APP_THEMES } from 'redux-store/constants';

import { NavLink, withRouter } from 'react-router-dom';
import styles from './header.module.scss';

import nav from 'setts/navigation';

import Logo from 'components/Logo';
import Icon from 'components/UI/Icons';

import EshopLink from './EShopLink';

const DesktopHeader = ({
  phones,
  services,
  history,
  toggleContact,
  appTheme,
}) => {
  const [selected, setSelected] = useState([]);
  const [_services, setServices] = useState(services);

  useEffect(() => {
    if (services && services.length > 0) {
      const temp = services.sort((a, b) =>
        a.title === 'Дополнительные услуги' ? 1 : -1,
      );
      setServices(temp);
      setSelected(temp[0]);
    }
  }, [services]);

  useEffect(() => {
    const unlisten = history.listen((location, action) => {
      setSelected([]);
    });

    return () => {
      unlisten();
    };
  });

  const sublist = () => {
    return (
      <ul className={styles.sublist_list}>
        {_services.map((serv) => (
          <li
            key={serv.title}
            className={styles.sublist_item}
            onMouseEnter={() => setSelected(serv.children)}
          >
            <NavLink to={`/category-service/${serv.path}`}>
              {serv.title}
            </NavLink>
            <Icon name='caret-right' />
          </li>
        ))}
      </ul>
    );
  };

  const sublistServices = () => {
    return (
      <ul className={styles.sublistSelected_list}>
        {selected.map((serv) =>
          serv.level ? (
            serv.children.map((i) => (
              <li
                key={serv.title + Math.random() * 1000 * Date.now()}
                className={styles.sublistSelected_item}
              >
                <NavLink to={`/service/${i.path}`}>
                  <p className={styles.title}>{i.title}</p>
                </NavLink>
              </li>
            ))
          ) : (
            <li key={serv.title} className={styles.sublistSelected_item}>
              <NavLink to={`/service/${serv.path}`}>
                <p className={styles.title}>{serv.title}</p>
              </NavLink>
            </li>
          ),
        )}
      </ul>
    );
  };

  return (
    <div
      className={classnames(styles.container, {
        [styles.darkTheme]: appTheme === APP_THEMES.dark,
      })}
    >
      <div className='ba-wrap'>
        <div className={styles.inner}>
          <p className={styles.logo}>
            <NavLink
              to='/'
              aria-label='Go Main'
              exact
              onClick={() => window.scrollTo(0, 0)}
            >
              <Logo />
            </NavLink>
          </p>

          <nav className={styles.nav_wrap}>
            <ul className={styles.nav}>
              {nav.map((i) => (
                <li
                  key={i.route}
                  className={classnames(styles.nav_item, {
                    [styles.sublist_wrap]: i.label === 'Услуги центра',
                  })}
                >
                  {i.label !== 'Услуги центра' && (
                    <NavLink
                      to={i.route}
                      exact
                      onClick={() => window.scrollTo(0, 0)}
                      className={classnames(styles.link)}
                    >
                      {i.label}
                    </NavLink>
                  )}
                  {i.label === 'Услуги центра' && (
                    <>
                      <NavLink
                        to={i.route}
                        className={classnames(styles.link)}
                        exact
                        onClick={() => window.scrollTo(0, 0)}
                      >
                        {i.label} <Icon name='caret' />
                      </NavLink>

                      <div
                        className={styles.sublist}
                        onMouseLeave={() => setSelected([])}
                      >
                        {sublist()}

                        {selected.length > 0 && sublistServices()}
                      </div>
                    </>
                  )}
                </li>
              ))}

              <EshopLink styles={styles} />

              <li>
                <p
                  className={classnames(styles.openContact, styles.phone)}
                  onClick={toggleContact}
                >
                  <Icon name='phone' />
                  <b>{phones[0]}</b>
                  <Icon name='caret' />
                </p>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ web }) => ({
  services: web.servicesList,
});
const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

const connectAndWrap =
  (
    mapStateToProps = null,
    mapDispatchToProps = null,
    mergeProps = null,
    options = {},
  ) =>
  (component) =>
    connect(mapStateToProps, mapDispatchToProps, mergeProps, {
      ...options,
      withRouter: true,
    })(withRouter(component));

export default connectAndWrap(
  mapStateToProps,
  mapDispatchToProps,
)(DesktopHeader);
